import React, { Component } from 'react';
import {
  Drawer,
  Form,
  Icon,
  Button,
  Col,
  Row,
  Input,
  Select,
  Modal,
} from 'antd';
import styles from '../Inference.module.css';

const { Option } = Select;

class InferenceSettings extends Component {
  state = {
    visible: false,
  };

  showDrawer = () => {
    this.setState({
      visible: true,
    });
  };

  onClose = () => {
    this.setState({
      visible: false,
    });
  };

  component = () => {
    const { modal, modalClose, onSubmit } = this.props;
    return (
      <Form layout="vertical" hideRequiredMark>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              className="loginFormField dropdownFormField"
              name="config1"
              label="Config 1"
              rules={[
                {
                  required: true,
                  message: 'Please enter config 1',
                },
              ]}
            >
              <Input
                className={styles.fieldInput}
                placeholder="Please enter config 1"
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="config2"
              label="Config 2"
              rules={[
                {
                  required: true,
                  message: 'Please enter config 2',
                },
              ]}
            >
              <Input
                className={styles.fieldInput}
                placeholder="Please enter config 2"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="config3"
              label="Config3"
              rules={[
                {
                  required: true,
                  message: 'Please select an owner',
                },
              ]}
            >
              <Select
                className="fieldSelect"
                dropdownClassName="fieldSelectDropdownClassName"
                placeholder="Please select config 3"
              >
                <Option value="test1">Test 1</Option>
                <Option value="test2">Test 2</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="config4"
              label="Config4"
              rules={[
                {
                  required: true,
                  message: 'Please choose Config 4',
                },
              ]}
            >
              <Select
                className="fieldSelect"
                dropdownClassName="fieldSelectDropdownClassName"
                placeholder="Please choose config 4"
              >
                <Option value="test1">Test 1</Option>
                <Option value="test2">Test 2</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="config5"
              label="Config 5"
              rules={[
                {
                  required: true,
                  message: 'Please choose config 5',
                },
              ]}
            >
              <Select
                className="fieldSelect"
                dropdownClassName="fieldSelectDropdownClassName"
                placeholder="Please choose config 5"
              >
                <Option value="test1">Test 1</Option>
                <Option value="test2">Test 2</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="config6"
              label="Config 6"
              rules={[
                {
                  required: true,
                  message: 'Please choose config 6',
                },
              ]}
            >
              <Input
                className={styles.fieldInput}
                placeholder="Please config 6"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row
          style={{
            marginTop: '30px',
          }}
        >
          <Button
            className={styles.linkButton}
            onClick={modal ? modalClose : this.onClose}
            style={{
              marginRight: 8,
            }}
          >
            Cancel
          </Button>
          <Button
            style={{
              width: '150px',
            }}
            className={styles.primaryButton}
            onClick={modal ? onSubmit : this.onClose}
            type="primary"
          >
            {modal ? 'Start Inference' : 'Restart Inference'}
          </Button>
        </Row>
      </Form>
    );
  };

  render() {
    const { modal, modalClose } = this.props;
    return (
      <div>
        {!modal && (
          <Icon
            className={styles.settings}
            onClick={this.showDrawer}
            type="setting"
          />
        )}
        {modal ? (
          <Modal
            title="Configuration"
            onCancel={modalClose}
            visible
            className={styles.inferenceModal}
          >
            {this.component()}
          </Modal>
        ) : (
          <Drawer
            title="Configuration"
            width={720}
            onClose={this.onClose}
            visible={this.state.visible}
            bodyStyle={{
              paddingBottom: 80,
            }}
            placement="left"
          >
            {this.component()}
          </Drawer>
        )}
      </div>
    );
  }
}

export default InferenceSettings;
